<template>
  <div class="template-data-tile"
       :class="{'main-top-layout': topRoute}"
       v-loading="tile.loading"
       element-loading-text="页面加载中，请稍等...">
    <div class="data-tile">
      <AsyncComponent v-if="tile.component"
                      :component-path="tile.component"></AsyncComponent>
      <template v-else>
        <Hint class="tile-load-failed" :icon="false" v-if="!tile.loading">
          <span>页面加载失败</span>
          <div class="button-group">
            <el-button type="primary" size="mini" plain @click="loadTileData">点击重试</el-button>
          </div>
        </Hint>
      </template>
    </div>
  </div>
</template>

<script>
import baseApiUrl from '../../constants/baseApiUrl'
import routeConfig from '../../constants/routeConfig'
import Support from '../../mixins/support'
import AsyncComponent from '../elements/async/AsyncComponent'
import Hint from '../elements/Hint'
export default {
  mixins: [Support],
  name: 'TemplateDataTile',
  components: {
    AsyncComponent,
    Hint
  },
  data () {
    return {
      tile: {
        loading: false,
        loaded: false,
        component: null
      }
    }
  },
  methods: {
    loadTileData () {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataTile.param]) {
        return
      }
      this.tile.loading = true
      this.$ajax({
        url: baseApiUrl.DataTileUrl,
        method: 'post',
        data: this.$qs.stringify(postParams, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          this.tile.component = response.data['component']
        }
      }).finally(() => {
        this.tile.loading = false
        this.tile.loaded = true
      })
    }
  },
  mounted () {
    this.loadTileData()
  },
  activated () {
    if (this.tile.loaded) {
      if (!this.tile.component) {
        this.loadTileData()
      }
    }
  }
}
</script>

<style lang="scss">
  .template-data-tile {
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    &.main-top-layout {
      padding: 10px;
    }
    & > .data-tile {
      position: relative;
      height: 100%;
      .tile-load-failed {
        .button-group {
          margin: 10px auto;
          text-align: center;
          .el-button {
            padding: 5px 12px;
            border-radius: 0;
          }
        }
      }
    }
  }
</style>
